angular.module("dx.webapp.validation", []);
